import React, { useState } from 'react';
import axios from 'axios';
import { Phone, Check, AlertCircle } from 'lucide-react';
import './PhoneVerification.css';

import { API as API_URL } from '../utils/apiConfig';

export const PhoneVerification = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('input'); // 'input' | 'verify' | 'success'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mockCode, setMockCode] = useState('');

  const sendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/phone/send-otp`, {
        phone_number: phoneNumber
      });

      if (response.data.mock_code) {
        setMockCode(response.data.mock_code);
      }

      setStep('verify');
    } catch (err) {
      setError(err.response?.data?.detail || 'SMS konnte nicht gesendet werden');
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/phone/verify-otp`, {
        phone_number: phoneNumber,
        code: code
      });

      if (response.data.valid) {
        setStep('success');
      } else {
        setError('Falscher Code. Bitte erneut versuchen.');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Verifizierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const resetFlow = () => {
    setPhoneNumber('');
    setCode('');
    setStep('input');
    setError('');
    setMockCode('');
  };

  return (
    <div className="phone-verification-container">
      <div className="phone-verification-card">
        {step === 'input' && (
          <>
            <div className="verification-header">
              <Phone size={48} className="verification-icon" />
              <h2>Telefon verifizieren</h2>
              <p>Wir senden dir einen 6-stelligen Code per SMS</p>
            </div>

            <form onSubmit={sendOTP} className="verification-form">
              <div className="form-group">
                <label>Telefonnummer</label>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="+49 151 12345678"
                  required
                  className="phone-input"
                />
              </div>

              {error && (
                <div className="error-message">
                  <AlertCircle size={18} />
                  <span>{error}</span>
                </div>
              )}

              <button
                type="submit"
                className="verify-button"
                disabled={loading || !phoneNumber}
              >
                {loading ? 'Wird gesendet...' : 'Code senden'}
              </button>
            </form>
          </>
        )}

        {step === 'verify' && (
          <>
            <div className="verification-header">
              <Phone size={48} className="verification-icon" />
              <h2>Code eingeben</h2>
              <p>Gib den 6-stelligen Code ein, den wir an {phoneNumber} gesendet haben</p>
            </div>

            {mockCode && (
              <div className="mock-code-info">
                <AlertCircle size={18} />
                <span>
                  <strong>Test-Modus:</strong> Dein Code ist <strong>{mockCode}</strong>
                </span>
              </div>
            )}

            <form onSubmit={verifyOTP} className="verification-form">
              <div className="form-group">
                <label>Verifikations-Code</label>
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  placeholder="123456"
                  maxLength={6}
                  required
                  className="code-input"
                  autoFocus
                />
              </div>

              {error && (
                <div className="error-message">
                  <AlertCircle size={18} />
                  <span>{error}</span>
                </div>
              )}

              <div className="verification-actions">
                <button
                  type="submit"
                  className="verify-button"
                  disabled={loading || code.length !== 6}
                >
                  {loading ? 'Wird verifiziert...' : 'Verifizieren'}
                </button>
                
                <button
                  type="button"
                  onClick={resetFlow}
                  className="back-button"
                >
                  Nummer ändern
                </button>
              </div>
            </form>
          </>
        )}

        {step === 'success' && (
          <div className="verification-success">
            <div className="success-icon">
              <Check size={64} />
            </div>
            <h2>Erfolgreich verifiziert!</h2>
            <p>Deine Telefonnummer wurde bestätigt</p>
            <button
              onClick={() => window.location.href = '/profile'}
              className="done-button"
            >
              Fertig
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
